const obfuscatePhone = (string) => {
    if (!string)
        return '';

    string = string.replaceAll(' ', '');

    return `${string.slice(0,4)}****${string.slice(8, 15)}`;
};

export default obfuscatePhone;